import { Common } from '~/models/common';
import { Image } from '~/models/image';
import { Form } from '~/models/form';
import { Seo } from '~/models/seo';

export namespace Practice {
	export const collection = 'practice';
	export const api = `/api/${collection}`;

	export type Model = Common.Model & {
		title: string;
		alias: string;
		number: string;
		description: string;
		link: string;
		showOnAbout: boolean;
		images: Image.Model[];
		text: string | null;
		button: string;
		form: Form.Model | null;
		seo: Seo.Model;
	};

	export const modelState: Model = {
		...Common.modelState,
		title: '',
		alias: '',
		number: '',
		description: '',
		link: '',
		showOnAbout: false,
		images: [],
		text: '',
		button: '',
		form: null,
		seo: Seo.modelState,
	};
}
